module.exports = __webpack_public_path__ + "static/img/shareImg1.9036eed0.png";